//#region import libraries
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Container, Row, Col, Image, Alert } from 'react-bootstrap';
import { LoginPage } from '_molecules';
import { setLogoutAlert, selectLogoutAlert } from '_redux/slices/main-screen/modal'
import image from "_assets/images/PRM-Logo-PNG/white-text.png";
import { Colors } from '_styles';
import { useIsMobile } from '_utils/hooks';
//#endregion

const Register = () => {
  const dispatch = useDispatch();
  const showLogoutAlert = useSelector(selectLogoutAlert);
  // phones: blue logo band across the top instead of a full-height side panel
  const isMobile = useIsMobile();

  return (
    <>
      <Container fluid={true}>
        <Row>
          <Col xs={12} md={3} className={isMobile ? "py-3" : "vh-100 justify-content-md-center"} style={{ backgroundColor: Colors.PRM_LIGHT_BLUE }}>
            <Container className={isMobile ? "d-flex justify-content-center" : "mt-5 d-flex justify-content-center"}>
              <Image src={image} height={isMobile ? 36 : 50} />
            </Container>
          </Col>

          <Col xs={12} md className={isMobile ? "mt-2 pb-5" : "vh-100 mt-5"}>
            {showLogoutAlert &&
              <Alert variant="info" onClose={() => dispatch(setLogoutAlert(false))} dismissible>
                <Alert.Heading>Your session has expired</Alert.Heading>
                <p>For security your session has timed out, log back in to access the portal.</p>
              </Alert>
            }
            <LoginPage />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Register;
